'use strict';

import React from 'react';
import Collapsible from 'react-collapsible';

import { FormattedMessage } from 'react-intl';
import OTIcon from '../tag/OTIcon';
import MedixineQuestionnaireListItem from './medixine/QuestionnaireListItem';
import OmavointiQuestionnaireListItem from './omavointi/QuestionnaireListItem';
import OmavointiQuestionnaireActiveList from './omavointi/QuestionnaireActiveList';
import GTIQuestionnaireListItem from './gti/QuestionnaireListItem';
import AssignedQuestionnaires from './formula/AssignedQuestionnaires';
import { partition } from 'lodash';
import AivaListItem from './AivaListItem';

const { id: module_id } = module;

class QuestionnaireContainer extends React.Component {
  render() {
    const { open, items, type, children, aiva } = this.props;

    let [omavointiQuestionnaires, otherQuestionnaires] = partition(
      items,
      (item) =>
        item.type === 'OmavointiQuestionnaire' &&
        item.formCode !== 'feeling_app' &&
        (item.status === 'ACTIVE' || item.status === 'STARTED')
    );

    /* Count multiple omavointi questionnaires as one, because omavointi questionnaires are bundled */
    let questionnairesCount = aiva
      ? aiva.length
      : (otherQuestionnaires && otherQuestionnaires.length > 0
          ? otherQuestionnaires.length
          : 0) +
        (omavointiQuestionnaires && omavointiQuestionnaires.length > 0 ? 1 : 0);

    let assignedForms = [];
    items?.map((questionnaire) => {
      if (Object.getOwnPropertyDescriptor(questionnaire, 'formulaFormId')) {
        assignedForms.push(questionnaire);
      }
    });

    const trigger = (
      <h2>
        <OTIcon
          config={{
            type: 'custom',
            name: type === 'Answered' ? 'kyselyt-taytetyt' : 'kyselyt',
          }}
          style={{ width: '14px', height: '16px' }}
        />
        <span style={{ marginLeft: '10px' }} className={'bold'}>
          <FormattedMessage id={`${module_id}.questionnairestatus.${type}`} /> (
          {questionnairesCount})
        </span>
      </h2>
    );

    return (
      <Collapsible
        /* open is null by default */
        open={open || true}
        className="ot-collapsible"
        openedClassName="ot-collapsible"
        trigger={trigger}
      >
        <ul>
          {assignedForms.length > 0 && (
            <AssignedQuestionnaires forms={assignedForms} />
          )}
          {omavointiQuestionnaires.length > 0 && (
            <OmavointiQuestionnaireActiveList
              key={omavointiQuestionnaires[0].link}
              data={omavointiQuestionnaires}
            />
          )}
          {otherQuestionnaires.map((query, i) => {
            switch (query.type) {
              case 'Questionnaire':
                return (
                  <MedixineQuestionnaireListItem
                    key={`${query.link}_${i}`}
                    data={query}
                  />
                );
              case 'OmavointiQuestionnaire':
                return (
                  <OmavointiQuestionnaireListItem
                    key={`${query.link}_${i}`}
                    data={query}
                  />
                );
              case 'GTI':
                return <GTIQuestionnaireListItem key={'GTI'} />;
            }
          })}
          {aiva &&
            aiva.length > 0 &&
            aiva.map((process) => <AivaListItem aivaProcess={process} />)}
        </ul>
        {children}
      </Collapsible>
    );
  }
}

export default QuestionnaireContainer;
